import React from 'react';
import PropTypes from 'prop-types';

import { Flex, Image, Text, SvgIcon } from 'Components/Base';

const ModalContent = ({ imageUrl, title, description, iconName, countDownTimer }) => {
  return (
    <Flex flexDirection={'column'} alignItems={'center'}>
      {iconName ? (
        <SvgIcon icon={iconName} size={72} color={'primary'} />
      ) : (
        <Image src={imageUrl} />
      )}
      <Text
        textStyle={{ _: 'heading4', sm: 'heading2' }}
        fontWeight={'medium'}
        textAlign={'center'}
        mt={iconName ? 7 : 9}
      >
        {title}
      </Text>
      <Text
        mt={4}
        color={'greyscale.grey3'}
        textAlign={'center'}
        style={{ whiteSpace: 'pre-line' }}
      >
        {description}
      </Text>
      <Text color={'greyscale.grey3'} textAlign={'center'} style={{ whiteSpace: 'pre-line' }}>
        {countDownTimer}
      </Text>
    </Flex>
  );
};

ModalContent.propTypes = {
  iconName: PropTypes.string,
  imageUrl: PropTypes.string,
  title: PropTypes.string,
  countDownTimer: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

ModalContent.defaultProps = {
  imageUrl: 'https://assets.skooldio.com/classroom/course_review.svg',
};

export default ModalContent;
